import { cva as e } from "class-variance-authority";
// src/design/screen-state/style.ts
var t = e("flex items-center justify-center gap-2 py-16 text-sm text-muted-foreground"), n = () => ({ loading: t });
export { n as getStyles };

//# sourceMappingURL=style.js.map